import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';

Vue.use(Vuetify);

const opts = {
  theme: {
    dark: false,
    themes: {
      light: {
        primary: '#E85941',
      },
    },
    options: { customProperties: true },
  },
};

export default new Vuetify(opts);
